import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
    class: "PopupHeadline px-2 py-4 bg-brand_beige_light text-center",
    style: { "position": "sticky", "z-index": "2", "top": "0" }
};
const _hoisted_2 = /*#__PURE__*/ _createElementVNode("span", { class: "h5-responsive strong p-0 m-0 d-inline-block" }, "36 Monate Garantie", -1);
const _hoisted_3 = ["onClick"];
const _hoisted_4 = /*#__PURE__*/ _createElementVNode("div", { class: "row" }, [
    /*#__PURE__*/ _createElementVNode("div", { class: "col-12 px-4" }, [
        /*#__PURE__*/ _createElementVNode("p", { class: "h3-responsive [ mt-sm-45 mt-3 ] [ mb-sm-3 mb-2 ] text-lg-center text-left" }, [
            /*#__PURE__*/ _createTextVNode(" 36 Monate Geräteschutz mit der "),
            /*#__PURE__*/ _createElementVNode("span", { class: "d-inline-block" }, "mySWOOOP"),
            /*#__PURE__*/ _createTextVNode(" -Garantie ")
        ]),
        /*#__PURE__*/ _createElementVNode("p", { class: "text-lg-center text-left mb-45" }, [
            /*#__PURE__*/ _createTextVNode(" Erfahre mehr dazu in unseren "),
            /*#__PURE__*/ _createElementVNode("a", {
                href: "https://cdn.myschubert.com/docs/mySWOOOP_Garantiebedingungen_36M.pdf",
                class: "link-gray strong",
                title: "mySWOOOP Garantiebedingungen",
                target: "_blank"
            }, " Garantiebedingungen "),
            /*#__PURE__*/ _createTextVNode(" . ")
        ])
    ]),
    /*#__PURE__*/ _createElementVNode("div", { class: "col-12" }, [
        /*#__PURE__*/ _createElementVNode("div", { class: "row no-gutters" }, [
            /*#__PURE__*/ _createElementVNode("div", { class: "col-lg-8 pl-lg-5 pl-3 font7-responsive" }, [
                /*#__PURE__*/ _createElementVNode("img", {
                    src: "images/_new_brand/icons_in_brand_design/icon_guarantee.png",
                    alt: "36 Monate Garantie",
                    style: { "max-width": "39px", "max-height": "39px" },
                    class: "mb-3",
                    "data-max-width": "39",
                    "data-max-height": "39"
                }),
                /*#__PURE__*/ _createElementVNode("p", { class: "h6-responsive" }, "Umfang der Garantie"),
                /*#__PURE__*/ _createElementVNode("p", { class: "mb-45" }, " Du erhältst auf dein Gerät ab Kaufdatum 36 Monate Garantie. Diese umfasst alle Funktionen des gekauften Geräts, die bei der Werksauslieferung vom Hersteller als technische Spezifikationen des jeweiligen Geräts definiert wurden. Die gesetzlichen Gewährleistungsrechte bleiben gemäß der Garantiebedingungen durch die 36-Monate-Garantie unberührt. "),
                /*#__PURE__*/ _createElementVNode("img", {
                    src: "images/_new_brand/icons_in_brand_design/icon_repair.png",
                    alt: "Schnelle Reparatur",
                    style: { "max-width": "39px", "max-height": "39px" },
                    class: "mb-3",
                    "data-max-width": "39",
                    "data-max-height": "39"
                }),
                /*#__PURE__*/ _createElementVNode("p", { class: "h6-responsive" }, "Schnelle Reparatur oder Geräteaustausch"),
                /*#__PURE__*/ _createElementVNode("p", { class: "mb-45" }, " Funktioniert dein Gerät während des Garantiezeitraums nicht mehr einwandfrei, versuchen wir, es zu reparieren. Ist eine Reparatur nicht möglich, erhältst du von uns ein gleichwertiges Austauschgerät. Sollte auch ein Austausch nicht möglich sein, erstatten wir dir den Rechnungsbetrag für dein Gerät auf die beim Kauf genutzte Zahlungsart. "),
                /*#__PURE__*/ _createElementVNode("img", {
                    src: "images/_new_brand/icons_in_brand_design/icon_customer_support.png",
                    alt: "Kunden Support",
                    style: { "max-width": "39px", "max-height": "39px" },
                    class: "mb-3",
                    "data-max-width": "39",
                    "data-max-height": "39"
                }),
                /*#__PURE__*/ _createElementVNode("p", { class: "h6-responsive" }, "Problem im Garantiezeitraum melden"),
                /*#__PURE__*/ _createElementVNode("p", { class: "mb-5" }, " Wir sind von unseren refurbishten Geräten absolut überzeugt. Willst du dennoch einen Garantiefall reklamieren, kannst du die Garantieleistung telefonisch, per E-Mail oder vor Ort in unseren Stores anmelden – je nachdem, über welchen Kanal du deine ursprüngliche Bestellung getätigt hast. ")
            ]),
            /*#__PURE__*/ _createElementVNode("div", {
                class: "col-lg-4 d-lg-flex d-none flex-column align-items-center",
                style: {}
            }, [
                /*#__PURE__*/ _createElementVNode("img", {
                    src: "/images/garantie/36_Monate_Garantie_bei_mySWOOOP.png",
                    alt: "36 Monate Garantie bei mySWOOOP",
                    style: { "max-width": "80%" },
                    class: "d-block"
                }),
                /*#__PURE__*/ _createElementVNode("a", {
                    href: "https://cdn.myschubert.com/docs/mySWOOOP_Garantiebedingungen_36M.pdf",
                    target: "_blank",
                    title: "Zu den mySWOOOP Garantiebedingungen",
                    class: "mt-3 link-gray strong"
                }, " Garantiebedingungen ")
            ])
        ])
    ])
], -1);
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_v_card = _resolveComponent("v-card");
    const _component_v_dialog = _resolveComponent("v-dialog");
    return (_openBlock(), _createBlock(_component_v_dialog, {
        class: "guaranteePopup",
        modelValue: _ctx.openPopup,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.openPopup) = $event)),
        width: "1100",
        "max-height": "80vh"
    }, {
        default: _withCtx(({ isActive }) => [
            _createVNode(_component_v_card, null, {
                default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_1, [
                        _hoisted_2,
                        _createElementVNode("i", {
                            onClick: ($event) => (isActive.value = false),
                            class: "icon-cancel pointerhover float-right pr-2"
                        }, null, 8, _hoisted_3)
                    ]),
                    _hoisted_4
                ]),
                _: 2
            }, 1024)
        ]),
        _: 1
    }, 8, ["modelValue"]));
}
